// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrumbs_wrapper__XYf0n"};